/* Testimonials for the INTERNATIONAL pages (/usa, /uae).

   The default set in TestimonialsSection is written for India: Priya M., Arun
   S., Meera K. and so on, with Indian portraits. On a page bought for US
   traffic that is the wrong social proof, which is why these exist.

   SOURCE: in-app feedback from Aura AI users, supplied by Dhruv on 2026-10-02
   together with the names of the users it came from. Text is VERBATIM.

   RULES, same as the /foreign page:
   - the name on a card must be the person who wrote that text. Names and texts
     arrived as two separate lists, so the pairing is in the order each was
     supplied and is Dhruv's to confirm.
   - never invent a reviewer, and never reuse one person's words under another
     name. A testimonial from someone who did not say it is exactly what the
     FTC endorsement rules penalise.
   - no ages or occupations: none were supplied, so none are shown.
   - PHOTOS ARE AI-GENERATED (Gemini), not photographs of these people. Same
     approach as the India avatars already in public/ugc/ and for the same
     reason the existing code gives: publishing a real person's likeness to
     endorse the app would be misappropriation. The accent gradient stays
     underneath as the fallback, so a failed image leaves a coloured disc.
   - the three texts used on /foreign are deliberately NOT repeated here, so no
     quote appears twice under two different names. */

export interface Testimonial {
  quote: string;
  author: string;
  accent: string;
  photo?: string;
  details?: string;
}

export const internationalTestimonials: Testimonial[] = [
  {
    quote:
      "I love how specific the readings can be. Instead of just giving generic astrology information, Aura AI gives you insights that feel much more personal. The explanations are clear and the app is very easy to use.",
    author: "Olivia Bennett",
    photo: "/ugc/avatar-olivia.jpg",
    accent: "linear-gradient(135deg, #ff2e93, #ff6b6b)",
  },
  {
    quote:
      "Really interesting astrology app. I liked how the readings were explained in simple language instead of making everything sound complicated. Some of the insights were surprisingly relatable.",
    author: "Ryan Mitchell",
    photo: "/ugc/avatar-ryan.jpg",
    accent: "linear-gradient(135deg, #8c42ff, #ff2e93)",
  },
  {
    quote:
      "I've been using Aura AI for a while now and really like the way it presents astrology. The readings are detailed, the app is fast, and everything is easy to navigate. It gives you a lot to explore without feeling overwhelming.",
    author: "Chloe Parker",
    photo: "/ugc/avatar-chloe.jpg",
    accent: "linear-gradient(135deg, #ff8c42, #ff2e93)",
  },
  {
    quote:
      "What I liked most is the level of detail. The readings cover different areas of life and explain the timing and possible developments clearly. It's been fun comparing the insights with what's actually happening in my life.",
    author: "Ethan Brooks",
    photo: "/ugc/avatar-ethan.jpg",
    accent: "linear-gradient(135deg, #2e8cff, #8c42ff)",
  },
];
